import ContactInfoItem from "../ContactInfoItem/ContactInfoItem";

export default function ContactCard({
  content,
  contactItems,
  HeaderIcon,
  MainButtonIcon,
  ActionIcon,
  whatsappHref,
}) {
  return (
    <article className="contact-card">
      <div className="contact-card__header">
        <div className="contact-card__header-icon">
          <HeaderIcon />
        </div>

        <div>
          <h3>Fale com a Dionara</h3>
          <p>Estamos aqui para te ajudar!</p>
        </div>
      </div>

      <div className="contact-card__list">
        {contactItems.map((item, index) => (
          <ContactInfoItem
            key={item.label}
            item={item}
            index={index}
            ActionIcon={ActionIcon}
          />
        ))}
      </div>

      <a
        href={whatsappHref}
        target="_blank"
        rel="noreferrer"
        className="contact-card__main-btn"
        aria-label={content.button}
      >
        <span>
          <MainButtonIcon />
        </span>

        {content.button}

        <b>
          <ActionIcon />
        </b>
      </a>
    </article>
  );
}